//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_PHARMACIST_API_BASE_URL = new InjectionToken<string>('OM_PHARMACIST_API_BASE_URL');

export class ServiceBaseConfig {
  public key: string;
}

export class ServiceBase {
  private readonly apiKey: string;
  private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
  private readonly tenantIdHeaderName: string = 'TenantId';
  private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
  private readonly idTokenKey: string = 'samplicity-id-token';

  constructor(config: ServiceBaseConfig) {
    this.apiKey = config.key;
  }

  protected transformOptions(options: any) {
    let headers: HttpHeaders = options.headers;

    if (this.apiKey) {
      headers = headers.append(this.apimHeaderName, this.apiKey);
    }

    const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
    if (tenantId) {
      headers = headers.append(this.tenantIdHeaderName, tenantId);
    }

    const token = localStorage.getItem(this.idTokenKey);
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    options.headers = headers;

    return Promise.resolve(options);
  }
}

@Injectable()
export class OrderManagementPharmacist extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_PHARMACIST_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPharmacist(id: string | null | undefined): Observable<AjaxResponseOfPharmacistDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetPharmacist?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPharmacist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPharmacistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPharmacistDto>;
        }));
    }

    protected processGetPharmacist(response: HttpResponseBase): Observable<AjaxResponseOfPharmacistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPharmacistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    getPharmacistWithProgramConfigConditional(id: string | null | undefined, orderId: string | null | undefined): Observable<AjaxResponseOfPharmacistDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetPharmacistWithProgramConfigConditional?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPharmacistWithProgramConfigConditional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacistWithProgramConfigConditional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPharmacistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPharmacistDto>;
        }));
    }

    protected processGetPharmacistWithProgramConfigConditional(response: HttpResponseBase): Observable<AjaxResponseOfPharmacistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPharmacistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNewPharmacist(): Observable<AjaxResponseOfPharmacistDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetNewPharmacist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNewPharmacist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewPharmacist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPharmacistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPharmacistDto>;
        }));
    }

    protected processGetNewPharmacist(response: HttpResponseBase): Observable<AjaxResponseOfPharmacistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPharmacistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    searchPharmacists(filter: PharmacistSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfPharmacistSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/SearchPharmacists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchPharmacists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPharmacists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPagedResultOfPharmacistSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPagedResultOfPharmacistSearchDto>;
        }));
    }

    protected processSearchPharmacists(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfPharmacistSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPagedResultOfPharmacistSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pharmacist (optional) 
     * @return Success
     */
    updatePharmacist(pharmacist: PharmacistDto | null | undefined): Observable<AjaxResponseOfPharmacistDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/UpdatePharmacist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pharmacist);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePharmacist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePharmacist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPharmacistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPharmacistDto>;
        }));
    }

    protected processUpdatePharmacist(response: HttpResponseBase): Observable<AjaxResponseOfPharmacistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPharmacistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pharmacistDto (optional) 
     * @return Success
     */
    createUpdatePharmacist(pharmacistDto: PharmacistDto | null | undefined): Observable<AjaxResponseOfPharmacistDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/CreateUpdatePharmacist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pharmacistDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUpdatePharmacist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdatePharmacist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPharmacistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPharmacistDto>;
        }));
    }

    protected processCreateUpdatePharmacist(response: HttpResponseBase): Observable<AjaxResponseOfPharmacistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPharmacistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pharmacyId (optional) 
     * @return Success
     */
    getPharmacistsByPharmacyId(pharmacyId: string | null | undefined): Observable<AjaxResponseOfListOfPharmacistDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetPharmacistsByPharmacyId?";
        if (pharmacyId !== undefined && pharmacyId !== null)
            url_ += "pharmacyId=" + encodeURIComponent("" + pharmacyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPharmacistsByPharmacyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacistsByPharmacyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfPharmacistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfPharmacistDto>;
        }));
    }

    protected processGetPharmacistsByPharmacyId(response: HttpResponseBase): Observable<AjaxResponseOfListOfPharmacistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfPharmacistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hospitalId (optional) 
     * @return Success
     */
    getPharmaciesByHospitalId(hospitalId: string | null | undefined): Observable<AjaxResponseOfListOfPharmacyDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetPharmaciesByHospitalId?";
        if (hospitalId !== undefined && hospitalId !== null)
            url_ += "hospitalId=" + encodeURIComponent("" + hospitalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPharmaciesByHospitalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmaciesByHospitalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfPharmacyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfPharmacyDto>;
        }));
    }

    protected processGetPharmaciesByHospitalId(response: HttpResponseBase): Observable<AjaxResponseOfListOfPharmacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfPharmacyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hospitalId (optional) 
     * @return Success
     */
    getHospitalDetailById(hospitalId: string | null | undefined): Observable<AjaxResponseOfHospitalDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetHospitalDetailById?";
        if (hospitalId !== undefined && hospitalId !== null)
            url_ += "hospitalId=" + encodeURIComponent("" + hospitalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetHospitalDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfHospitalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfHospitalDto>;
        }));
    }

    protected processGetHospitalDetailById(response: HttpResponseBase): Observable<AjaxResponseOfHospitalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfHospitalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pharmacyId (optional) 
     * @return Success
     */
    getPharmacyDetailById(pharmacyId: string | null | undefined): Observable<AjaxResponseOfPharmacyDto> {
        let url_ = this.baseUrl + "/api/services/app/Pharmacist/GetPharmacyDetailById?";
        if (pharmacyId !== undefined && pharmacyId !== null)
            url_ += "pharmacyId=" + encodeURIComponent("" + pharmacyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPharmacyDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPharmacyDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPharmacyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPharmacyDto>;
        }));
    }

    protected processGetPharmacyDetailById(response: HttpResponseBase): Observable<AjaxResponseOfPharmacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPharmacyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AjaxResponseOfPharmacistDto implements IAjaxResponseOfPharmacistDto {
    result: PharmacistDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPharmacistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PharmacistDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPharmacistDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPharmacistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPharmacistDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPharmacistDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPharmacistDto {
    result: PharmacistDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PharmacistDto implements IPharmacistDto {
    id: string | undefined;
    /** Classification ID for the Pharmacist suffix */
    suffixClassificationValueId: string | undefined;
    currentStatusClassificationValueId: string | undefined;
    userProfileId: string | undefined;
    clientPharmacistId: string | undefined;
    oldClientPharmacistId: string | undefined;
    knipperId: string | undefined;
    oldKnipperPharmacistId: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    knipperCreateFlag: boolean | undefined;
    npiNbr: string | undefined;
    variableField1Text: string | undefined;
    variableField2Text: string | undefined;
    variableField3Text: string | undefined;
    srfExpirationDateIncludeFlag: boolean | undefined;
    deaIncludeFlag: boolean | undefined;
    specialtyIncludeFlag: boolean | undefined;
    sanIncludeFlag: boolean | undefined;
    professionalDesignationMdIncludeFlag: boolean | undefined;
    professionalDesignationDoIncludeFlag: boolean | undefined;
    professionalDesignationNpIncludeFlag: boolean | undefined;
    professionalDesignationPaIncludeFlag: boolean | undefined;
    professionalDesignationOtherIncludeFlag: boolean | undefined;
    contactMethods: PharmacistContactMethodDto[] | undefined;
    licenses: PharmacistLicenseDto[] | undefined;
    /** Gets or sets the pharmacies. */
    pharmacies: PharmacyDto[] | undefined;
    /** Gets or sets the hospitals. */
    hospitals: HospitalDto[] | undefined;
    /** Gets or sets the professional designations. */
    professionalDesignations: PharmacistProfessionalDesignationDto[] | undefined;
    sourceText: string | undefined;
    sourceNoteText: string | undefined;
    sourceUpdateDateTime: Date | undefined;
    names: LocalizedValue[] | undefined;

    constructor(data?: IPharmacistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.suffixClassificationValueId = _data["suffixClassificationValueId"];
            this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
            this.userProfileId = _data["userProfileId"];
            this.clientPharmacistId = _data["clientPharmacistId"];
            this.oldClientPharmacistId = _data["oldClientPharmacistId"];
            this.knipperId = _data["knipperId"];
            this.oldKnipperPharmacistId = _data["oldKnipperPharmacistId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            this.npiNbr = _data["npiNbr"];
            this.variableField1Text = _data["variableField1Text"];
            this.variableField2Text = _data["variableField2Text"];
            this.variableField3Text = _data["variableField3Text"];
            this.srfExpirationDateIncludeFlag = _data["srfExpirationDateIncludeFlag"];
            this.deaIncludeFlag = _data["deaIncludeFlag"];
            this.specialtyIncludeFlag = _data["specialtyIncludeFlag"];
            this.sanIncludeFlag = _data["sanIncludeFlag"];
            this.professionalDesignationMdIncludeFlag = _data["professionalDesignationMdIncludeFlag"];
            this.professionalDesignationDoIncludeFlag = _data["professionalDesignationDoIncludeFlag"];
            this.professionalDesignationNpIncludeFlag = _data["professionalDesignationNpIncludeFlag"];
            this.professionalDesignationPaIncludeFlag = _data["professionalDesignationPaIncludeFlag"];
            this.professionalDesignationOtherIncludeFlag = _data["professionalDesignationOtherIncludeFlag"];
            if (Array.isArray(_data["contactMethods"])) {
                this.contactMethods = [] as any;
                for (let item of _data["contactMethods"])
                    this.contactMethods.push(PharmacistContactMethodDto.fromJS(item));
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses.push(PharmacistLicenseDto.fromJS(item));
            }
            if (Array.isArray(_data["pharmacies"])) {
                this.pharmacies = [] as any;
                for (let item of _data["pharmacies"])
                    this.pharmacies.push(PharmacyDto.fromJS(item));
            }
            if (Array.isArray(_data["hospitals"])) {
                this.hospitals = [] as any;
                for (let item of _data["hospitals"])
                    this.hospitals.push(HospitalDto.fromJS(item));
            }
            if (Array.isArray(_data["professionalDesignations"])) {
                this.professionalDesignations = [] as any;
                for (let item of _data["professionalDesignations"])
                    this.professionalDesignations.push(PharmacistProfessionalDesignationDto.fromJS(item));
            }
            this.sourceText = _data["sourceText"];
            this.sourceNoteText = _data["sourceNoteText"];
            this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PharmacistDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["suffixClassificationValueId"] = this.suffixClassificationValueId;
        data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
        data["userProfileId"] = this.userProfileId;
        data["clientPharmacistId"] = this.clientPharmacistId;
        data["oldClientPharmacistId"] = this.oldClientPharmacistId;
        data["knipperId"] = this.knipperId;
        data["oldKnipperPharmacistId"] = this.oldKnipperPharmacistId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        data["npiNbr"] = this.npiNbr;
        data["variableField1Text"] = this.variableField1Text;
        data["variableField2Text"] = this.variableField2Text;
        data["variableField3Text"] = this.variableField3Text;
        data["srfExpirationDateIncludeFlag"] = this.srfExpirationDateIncludeFlag;
        data["deaIncludeFlag"] = this.deaIncludeFlag;
        data["specialtyIncludeFlag"] = this.specialtyIncludeFlag;
        data["sanIncludeFlag"] = this.sanIncludeFlag;
        data["professionalDesignationMdIncludeFlag"] = this.professionalDesignationMdIncludeFlag;
        data["professionalDesignationDoIncludeFlag"] = this.professionalDesignationDoIncludeFlag;
        data["professionalDesignationNpIncludeFlag"] = this.professionalDesignationNpIncludeFlag;
        data["professionalDesignationPaIncludeFlag"] = this.professionalDesignationPaIncludeFlag;
        data["professionalDesignationOtherIncludeFlag"] = this.professionalDesignationOtherIncludeFlag;
        if (Array.isArray(this.contactMethods)) {
            data["contactMethods"] = [];
            for (let item of this.contactMethods)
                data["contactMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        if (Array.isArray(this.pharmacies)) {
            data["pharmacies"] = [];
            for (let item of this.pharmacies)
                data["pharmacies"].push(item.toJSON());
        }
        if (Array.isArray(this.hospitals)) {
            data["hospitals"] = [];
            for (let item of this.hospitals)
                data["hospitals"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalDesignations)) {
            data["professionalDesignations"] = [];
            for (let item of this.professionalDesignations)
                data["professionalDesignations"].push(item.toJSON());
        }
        data["sourceText"] = this.sourceText;
        data["sourceNoteText"] = this.sourceNoteText;
        data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        return data;
    }

    clone(): PharmacistDto {
        const json = this.toJSON();
        let result = new PharmacistDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacistDto {
    id: string | undefined;
    /** Classification ID for the Pharmacist suffix */
    suffixClassificationValueId: string | undefined;
    currentStatusClassificationValueId: string | undefined;
    userProfileId: string | undefined;
    clientPharmacistId: string | undefined;
    oldClientPharmacistId: string | undefined;
    knipperId: string | undefined;
    oldKnipperPharmacistId: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    knipperCreateFlag: boolean | undefined;
    npiNbr: string | undefined;
    variableField1Text: string | undefined;
    variableField2Text: string | undefined;
    variableField3Text: string | undefined;
    srfExpirationDateIncludeFlag: boolean | undefined;
    deaIncludeFlag: boolean | undefined;
    specialtyIncludeFlag: boolean | undefined;
    sanIncludeFlag: boolean | undefined;
    professionalDesignationMdIncludeFlag: boolean | undefined;
    professionalDesignationDoIncludeFlag: boolean | undefined;
    professionalDesignationNpIncludeFlag: boolean | undefined;
    professionalDesignationPaIncludeFlag: boolean | undefined;
    professionalDesignationOtherIncludeFlag: boolean | undefined;
    contactMethods: PharmacistContactMethodDto[] | undefined;
    licenses: PharmacistLicenseDto[] | undefined;
    /** Gets or sets the pharmacies. */
    pharmacies: PharmacyDto[] | undefined;
    /** Gets or sets the hospitals. */
    hospitals: HospitalDto[] | undefined;
    /** Gets or sets the professional designations. */
    professionalDesignations: PharmacistProfessionalDesignationDto[] | undefined;
    sourceText: string | undefined;
    sourceNoteText: string | undefined;
    sourceUpdateDateTime: Date | undefined;
    names: LocalizedValue[] | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class PharmacistContactMethodDto implements IPharmacistContactMethodDto {
    pharmacistId: string | undefined;
    pharmacistAddressId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    knipperCreateFlag: boolean | undefined;
    primaryContactMethodFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IPharmacistContactMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacistId = _data["pharmacistId"];
            this.pharmacistAddressId = _data["pharmacistAddressId"];
            this.contactMethodTypeId = _data["contactMethodTypeId"];
            this.contactDetailText = _data["contactDetailText"];
            this.contactDetailExtensionText = _data["contactDetailExtensionText"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacistContactMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacistContactMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacistId"] = this.pharmacistId;
        data["pharmacistAddressId"] = this.pharmacistAddressId;
        data["contactMethodTypeId"] = this.contactMethodTypeId;
        data["contactDetailText"] = this.contactDetailText;
        data["contactDetailExtensionText"] = this.contactDetailExtensionText;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacistContactMethodDto {
        const json = this.toJSON();
        let result = new PharmacistContactMethodDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacistContactMethodDto {
    pharmacistId: string | undefined;
    pharmacistAddressId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    knipperCreateFlag: boolean | undefined;
    primaryContactMethodFlag: boolean | undefined;
    id: string | undefined;
}

export class PharmacistLicenseDto implements IPharmacistLicenseDto {
    pharmacistId: string | undefined;
    stateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    sampleEligibilityFlag: boolean | undefined;
    licenseExpirationDate: Date | undefined;
    id: string | undefined;

    constructor(data?: IPharmacistLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacistId = _data["pharmacistId"];
            this.stateCode = _data["stateCode"];
            this.stateLicenseNbr = _data["stateLicenseNbr"];
            this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? new Date(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacistLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacistLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacistId"] = this.pharmacistId;
        data["stateCode"] = this.stateCode;
        data["stateLicenseNbr"] = this.stateLicenseNbr;
        data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacistLicenseDto {
        const json = this.toJSON();
        let result = new PharmacistLicenseDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacistLicenseDto {
    pharmacistId: string | undefined;
    stateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    sampleEligibilityFlag: boolean | undefined;
    licenseExpirationDate: Date | undefined;
    id: string | undefined;
}

/** Class to represent pharmacy. */
export class PharmacyDto implements IPharmacyDto {
    /** Gets or sets the pharmacy name. */
    pharmacyName: string | undefined;
    /** Gets to sets the KnipperId. */
    knipperId: string | undefined;
    /** Gets to sets the client pharmacy id. */
    clientPharmacyId: string | undefined;
    /** Gets to sets the classification value of pharmacy. */
    currentStatusClassificationValueId: string | undefined;
    /** Gets or Sets the  knipper created pharmacy flag. */
    knipperCreateFlag: boolean | undefined;
    /** Gets or sets the pharmacy contact methods. */
    contactMethods: PharmacyContactMethodDto[] | undefined;
    /** Gets or sets the pharmacy addresses. */
    addresses: PharmacyAddressDto[] | undefined;
    /** Gets or sets the pharmacy licenses */
    licenses: PharmacyLicenseDto[] | undefined;
    hospitals: PharmacyHospitalDto[] | undefined;
    pharmacists: PharmacistDto[] | undefined;
    /** Gets or sets the pharmacy current status. */
    currentStatus: ReferencedClassification | undefined;
    /** Gets or sets the programs of the Pharmacy */
    programNames: string[] | undefined;
    id: string | undefined;

    constructor(data?: IPharmacyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacyName = _data["pharmacyName"];
            this.knipperId = _data["knipperId"];
            this.clientPharmacyId = _data["clientPharmacyId"];
            this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            if (Array.isArray(_data["contactMethods"])) {
                this.contactMethods = [] as any;
                for (let item of _data["contactMethods"])
                    this.contactMethods.push(PharmacyContactMethodDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(PharmacyAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses.push(PharmacyLicenseDto.fromJS(item));
            }
            if (Array.isArray(_data["hospitals"])) {
                this.hospitals = [] as any;
                for (let item of _data["hospitals"])
                    this.hospitals.push(PharmacyHospitalDto.fromJS(item));
            }
            if (Array.isArray(_data["pharmacists"])) {
                this.pharmacists = [] as any;
                for (let item of _data["pharmacists"])
                    this.pharmacists.push(PharmacistDto.fromJS(item));
            }
            this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
            if (Array.isArray(_data["programNames"])) {
                this.programNames = [] as any;
                for (let item of _data["programNames"])
                    this.programNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacyName"] = this.pharmacyName;
        data["knipperId"] = this.knipperId;
        data["clientPharmacyId"] = this.clientPharmacyId;
        data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        if (Array.isArray(this.contactMethods)) {
            data["contactMethods"] = [];
            for (let item of this.contactMethods)
                data["contactMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        if (Array.isArray(this.hospitals)) {
            data["hospitals"] = [];
            for (let item of this.hospitals)
                data["hospitals"].push(item.toJSON());
        }
        if (Array.isArray(this.pharmacists)) {
            data["pharmacists"] = [];
            for (let item of this.pharmacists)
                data["pharmacists"].push(item.toJSON());
        }
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.programNames)) {
            data["programNames"] = [];
            for (let item of this.programNames)
                data["programNames"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacyDto {
        const json = this.toJSON();
        let result = new PharmacyDto();
        result.init(json);
        return result;
    }
}

/** Class to represent pharmacy. */
export interface IPharmacyDto {
    /** Gets or sets the pharmacy name. */
    pharmacyName: string | undefined;
    /** Gets to sets the KnipperId. */
    knipperId: string | undefined;
    /** Gets to sets the client pharmacy id. */
    clientPharmacyId: string | undefined;
    /** Gets to sets the classification value of pharmacy. */
    currentStatusClassificationValueId: string | undefined;
    /** Gets or Sets the  knipper created pharmacy flag. */
    knipperCreateFlag: boolean | undefined;
    /** Gets or sets the pharmacy contact methods. */
    contactMethods: PharmacyContactMethodDto[] | undefined;
    /** Gets or sets the pharmacy addresses. */
    addresses: PharmacyAddressDto[] | undefined;
    /** Gets or sets the pharmacy licenses */
    licenses: PharmacyLicenseDto[] | undefined;
    hospitals: PharmacyHospitalDto[] | undefined;
    pharmacists: PharmacistDto[] | undefined;
    /** Gets or sets the pharmacy current status. */
    currentStatus: ReferencedClassification | undefined;
    /** Gets or sets the programs of the Pharmacy */
    programNames: string[] | undefined;
    id: string | undefined;
}

export class HospitalDto implements IHospitalDto {
    /** Gets to sets the KnipperId. */
    knipperId: string | undefined;
    /** Gets to sets the client pharmacist id. */
    clientHospitalId: string | undefined;
    /** Gets to sets the classification value of pharmacist. */
    currentStatusClassificationValueId: string | undefined;
    /** Gets to sets the program enrolled for pharmacist. */
    programEnrolled: string | undefined;
    /** Gets to sets the hospital enrollment id. */
    enrollmentId: string | undefined;
    /** Gets or sets the hospital name. */
    hospitalName: string | undefined;
    /** Gets or Sets the  knipper created pharmacist flag. */
    knipperCreateFlag: boolean | undefined;
    pharmacies: PharmacyDto[] | undefined;
    pharmacists: PharmacistDto[] | undefined;
    addresses: HospitalAddressDto[] | undefined;
    licenses: HospitalLicenseDto[] | undefined;
    /** Gets or sets the pharmacy contact methods. */
    contactMethods: HospitalContactMethodDto[] | undefined;
    /** Gets or sets the Current status of the Hospital */
    currentStatus: ReferencedClassification | undefined;
    /** Gets or sets the Current programs of the Hospital */
    programs: ProgramDto[] | undefined;
    id: string | undefined;

    constructor(data?: IHospitalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knipperId = _data["knipperId"];
            this.clientHospitalId = _data["clientHospitalId"];
            this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
            this.programEnrolled = _data["programEnrolled"];
            this.enrollmentId = _data["enrollmentId"];
            this.hospitalName = _data["hospitalName"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            if (Array.isArray(_data["pharmacies"])) {
                this.pharmacies = [] as any;
                for (let item of _data["pharmacies"])
                    this.pharmacies.push(PharmacyDto.fromJS(item));
            }
            if (Array.isArray(_data["pharmacists"])) {
                this.pharmacists = [] as any;
                for (let item of _data["pharmacists"])
                    this.pharmacists.push(PharmacistDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(HospitalAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses.push(HospitalLicenseDto.fromJS(item));
            }
            if (Array.isArray(_data["contactMethods"])) {
                this.contactMethods = [] as any;
                for (let item of _data["contactMethods"])
                    this.contactMethods.push(HospitalContactMethodDto.fromJS(item));
            }
            this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs.push(ProgramDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HospitalDto {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knipperId"] = this.knipperId;
        data["clientHospitalId"] = this.clientHospitalId;
        data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
        data["programEnrolled"] = this.programEnrolled;
        data["enrollmentId"] = this.enrollmentId;
        data["hospitalName"] = this.hospitalName;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        if (Array.isArray(this.pharmacies)) {
            data["pharmacies"] = [];
            for (let item of this.pharmacies)
                data["pharmacies"].push(item.toJSON());
        }
        if (Array.isArray(this.pharmacists)) {
            data["pharmacists"] = [];
            for (let item of this.pharmacists)
                data["pharmacists"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        if (Array.isArray(this.contactMethods)) {
            data["contactMethods"] = [];
            for (let item of this.contactMethods)
                data["contactMethods"].push(item.toJSON());
        }
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): HospitalDto {
        const json = this.toJSON();
        let result = new HospitalDto();
        result.init(json);
        return result;
    }
}

export interface IHospitalDto {
    /** Gets to sets the KnipperId. */
    knipperId: string | undefined;
    /** Gets to sets the client pharmacist id. */
    clientHospitalId: string | undefined;
    /** Gets to sets the classification value of pharmacist. */
    currentStatusClassificationValueId: string | undefined;
    /** Gets to sets the program enrolled for pharmacist. */
    programEnrolled: string | undefined;
    /** Gets to sets the hospital enrollment id. */
    enrollmentId: string | undefined;
    /** Gets or sets the hospital name. */
    hospitalName: string | undefined;
    /** Gets or Sets the  knipper created pharmacist flag. */
    knipperCreateFlag: boolean | undefined;
    pharmacies: PharmacyDto[] | undefined;
    pharmacists: PharmacistDto[] | undefined;
    addresses: HospitalAddressDto[] | undefined;
    licenses: HospitalLicenseDto[] | undefined;
    /** Gets or sets the pharmacy contact methods. */
    contactMethods: HospitalContactMethodDto[] | undefined;
    /** Gets or sets the Current status of the Hospital */
    currentStatus: ReferencedClassification | undefined;
    /** Gets or sets the Current programs of the Hospital */
    programs: ProgramDto[] | undefined;
    id: string | undefined;
}

export class PharmacistProfessionalDesignationDto implements IPharmacistProfessionalDesignationDto {
    /** Gets or sets the pharmacistId. */
    pharmacistId: string | undefined;
    /** Gets or sets the Professional designationId. */
    professionalDesignationId: string | undefined;
    /** Gets or sets the primary flag of designation. */
    primaryFlag: boolean | undefined;
    /** Gets or sets the knipper create flag. */
    knipperCreateFlag: boolean | undefined;
    /** Gets or sets the pharmacist of designation. */
    pharmacist: PharmacistDto | undefined;
    id: string | undefined;

    constructor(data?: IPharmacistProfessionalDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacistId = _data["pharmacistId"];
            this.professionalDesignationId = _data["professionalDesignationId"];
            this.primaryFlag = _data["primaryFlag"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            this.pharmacist = _data["pharmacist"] ? PharmacistDto.fromJS(_data["pharmacist"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacistProfessionalDesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacistProfessionalDesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacistId"] = this.pharmacistId;
        data["professionalDesignationId"] = this.professionalDesignationId;
        data["primaryFlag"] = this.primaryFlag;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacistProfessionalDesignationDto {
        const json = this.toJSON();
        let result = new PharmacistProfessionalDesignationDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacistProfessionalDesignationDto {
    /** Gets or sets the pharmacistId. */
    pharmacistId: string | undefined;
    /** Gets or sets the Professional designationId. */
    professionalDesignationId: string | undefined;
    /** Gets or sets the primary flag of designation. */
    primaryFlag: boolean | undefined;
    /** Gets or sets the knipper create flag. */
    knipperCreateFlag: boolean | undefined;
    /** Gets or sets the pharmacist of designation. */
    pharmacist: PharmacistDto | undefined;
    id: string | undefined;
}

export class LocalizedValue implements ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;

    constructor(data?: ILocalizedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LocalizedValue {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }

    clone(): LocalizedValue {
        const json = this.toJSON();
        let result = new LocalizedValue();
        result.init(json);
        return result;
    }
}

export interface ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class PharmacyContactMethodDto implements IPharmacyContactMethodDto {
    pharmacyId: string | undefined;
    pharmacyAddressId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    knipperCreateFlag: boolean | undefined;
    primaryContactMethodFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IPharmacyContactMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacyId = _data["pharmacyId"];
            this.pharmacyAddressId = _data["pharmacyAddressId"];
            this.contactMethodTypeId = _data["contactMethodTypeId"];
            this.contactDetailText = _data["contactDetailText"];
            this.contactDetailExtensionText = _data["contactDetailExtensionText"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacyContactMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyContactMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacyId"] = this.pharmacyId;
        data["pharmacyAddressId"] = this.pharmacyAddressId;
        data["contactMethodTypeId"] = this.contactMethodTypeId;
        data["contactDetailText"] = this.contactDetailText;
        data["contactDetailExtensionText"] = this.contactDetailExtensionText;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacyContactMethodDto {
        const json = this.toJSON();
        let result = new PharmacyContactMethodDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacyContactMethodDto {
    pharmacyId: string | undefined;
    pharmacyAddressId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    knipperCreateFlag: boolean | undefined;
    primaryContactMethodFlag: boolean | undefined;
    id: string | undefined;
}

export class PharmacyAddressDto implements IPharmacyAddressDto {
    pharmacyId: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    primaryAddressFlag: boolean | undefined;
    badAddressFlag: boolean | undefined;
    clientAddressId: string | undefined;
    companyName: string | undefined;
    san: string | undefined;
    groupPracticeName: string | undefined;
    sanExpirationDate: Date | undefined;
    activeFlag: boolean | undefined;
    sourceText: string | undefined;
    sourceNoteText: string | undefined;
    fileName: string | undefined;
    sourceUpdateDateTime: Date | undefined;
    deletionSourceDataTime: Date | undefined;
    deaNbr: string | undefined;
    contactMethods: PharmacyContactMethodDto[] | undefined;
    addresses: PharmacyAddressDto[] | undefined;
    licenses: PharmacyLicenseDto[] | undefined;
    id: string | undefined;

    constructor(data?: IPharmacyAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacyId = _data["pharmacyId"];
            this.stateCode = _data["stateCode"];
            this.countryCode = _data["countryCode"];
            this.address1Text = _data["address1Text"];
            this.address2Text = _data["address2Text"];
            this.address3Text = _data["address3Text"];
            this.address4Text = _data["address4Text"];
            this.cityName = _data["cityName"];
            this.zipCode = _data["zipCode"];
            this.primaryAddressFlag = _data["primaryAddressFlag"];
            this.badAddressFlag = _data["badAddressFlag"];
            this.clientAddressId = _data["clientAddressId"];
            this.companyName = _data["companyName"];
            this.san = _data["san"];
            this.groupPracticeName = _data["groupPracticeName"];
            this.sanExpirationDate = _data["sanExpirationDate"] ? new Date(_data["sanExpirationDate"].toString()) : <any>undefined;
            this.activeFlag = _data["activeFlag"];
            this.sourceText = _data["sourceText"];
            this.sourceNoteText = _data["sourceNoteText"];
            this.fileName = _data["fileName"];
            this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
            this.deletionSourceDataTime = _data["deletionSourceDataTime"] ? new Date(_data["deletionSourceDataTime"].toString()) : <any>undefined;
            this.deaNbr = _data["deaNbr"];
            if (Array.isArray(_data["contactMethods"])) {
                this.contactMethods = [] as any;
                for (let item of _data["contactMethods"])
                    this.contactMethods.push(PharmacyContactMethodDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(PharmacyAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses.push(PharmacyLicenseDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacyAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacyId"] = this.pharmacyId;
        data["stateCode"] = this.stateCode;
        data["countryCode"] = this.countryCode;
        data["address1Text"] = this.address1Text;
        data["address2Text"] = this.address2Text;
        data["address3Text"] = this.address3Text;
        data["address4Text"] = this.address4Text;
        data["cityName"] = this.cityName;
        data["zipCode"] = this.zipCode;
        data["primaryAddressFlag"] = this.primaryAddressFlag;
        data["badAddressFlag"] = this.badAddressFlag;
        data["clientAddressId"] = this.clientAddressId;
        data["companyName"] = this.companyName;
        data["san"] = this.san;
        data["groupPracticeName"] = this.groupPracticeName;
        data["sanExpirationDate"] = this.sanExpirationDate ? this.sanExpirationDate.toISOString() : <any>undefined;
        data["activeFlag"] = this.activeFlag;
        data["sourceText"] = this.sourceText;
        data["sourceNoteText"] = this.sourceNoteText;
        data["fileName"] = this.fileName;
        data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
        data["deletionSourceDataTime"] = this.deletionSourceDataTime ? this.deletionSourceDataTime.toISOString() : <any>undefined;
        data["deaNbr"] = this.deaNbr;
        if (Array.isArray(this.contactMethods)) {
            data["contactMethods"] = [];
            for (let item of this.contactMethods)
                data["contactMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacyAddressDto {
        const json = this.toJSON();
        let result = new PharmacyAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacyAddressDto {
    pharmacyId: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    primaryAddressFlag: boolean | undefined;
    badAddressFlag: boolean | undefined;
    clientAddressId: string | undefined;
    companyName: string | undefined;
    san: string | undefined;
    groupPracticeName: string | undefined;
    sanExpirationDate: Date | undefined;
    activeFlag: boolean | undefined;
    sourceText: string | undefined;
    sourceNoteText: string | undefined;
    fileName: string | undefined;
    sourceUpdateDateTime: Date | undefined;
    deletionSourceDataTime: Date | undefined;
    deaNbr: string | undefined;
    contactMethods: PharmacyContactMethodDto[] | undefined;
    addresses: PharmacyAddressDto[] | undefined;
    licenses: PharmacyLicenseDto[] | undefined;
    id: string | undefined;
}

export class PharmacyLicenseDto implements IPharmacyLicenseDto {
    pharmacyId: string | undefined;
    stateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    sampleEligibilityFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IPharmacyLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacyId = _data["pharmacyId"];
            this.stateCode = _data["stateCode"];
            this.stateLicenseNbr = _data["stateLicenseNbr"];
            this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacyLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacyId"] = this.pharmacyId;
        data["stateCode"] = this.stateCode;
        data["stateLicenseNbr"] = this.stateLicenseNbr;
        data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacyLicenseDto {
        const json = this.toJSON();
        let result = new PharmacyLicenseDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacyLicenseDto {
    pharmacyId: string | undefined;
    stateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    sampleEligibilityFlag: boolean | undefined;
    id: string | undefined;
}

export class PharmacyHospitalDto implements IPharmacyHospitalDto {
    /** Gets or sets the hospital program Id */
    hospitalProgramId: string | undefined;
    /** Gets or sets the pharmacy program Id */
    pharmacyProgramId: string | undefined;
    /** Gets or sets the Pharmacy Affiliation To Hospital */
    affiliationTypeClassificationValueId: string | undefined;
    /** Gets or sets the certification status To Hospital */
    certificationStatusClassificationValueId: string | undefined;
    /** Gets to sets the KnipperId. */
    knipperId: string | undefined;
    /** Gets to sets the client pharmacist id. */
    clientHospitalId: string | undefined;
    /** Gets to sets the classification value of pharmacist. */
    currentStatusClassificationValueId: string | undefined;
    /** Gets to sets the program enrolled for pharmacist. */
    programEnrolled: string | undefined;
    /** Gets to sets the hospital enrollment id. */
    enrollmentId: string | undefined;
    /** Gets or sets the hospital name. */
    hospitalName: string | undefined;
    /** Gets or Sets the  knipper created pharmacist flag. */
    knipperCreateFlag: boolean | undefined;
    pharmacies: PharmacyDto[] | undefined;
    pharmacists: PharmacistDto[] | undefined;
    addresses: HospitalAddressDto[] | undefined;
    licenses: HospitalLicenseDto[] | undefined;
    /** Gets or sets the pharmacy contact methods. */
    contactMethods: HospitalContactMethodDto[] | undefined;
    /** Gets or sets the Current status of the Hospital */
    currentStatus: ReferencedClassification | undefined;
    /** Gets or sets the Current programs of the Hospital */
    programs: ProgramDto[] | undefined;
    id: string | undefined;

    constructor(data?: IPharmacyHospitalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hospitalProgramId = _data["hospitalProgramId"];
            this.pharmacyProgramId = _data["pharmacyProgramId"];
            this.affiliationTypeClassificationValueId = _data["affiliationTypeClassificationValueId"];
            this.certificationStatusClassificationValueId = _data["certificationStatusClassificationValueId"];
            this.knipperId = _data["knipperId"];
            this.clientHospitalId = _data["clientHospitalId"];
            this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
            this.programEnrolled = _data["programEnrolled"];
            this.enrollmentId = _data["enrollmentId"];
            this.hospitalName = _data["hospitalName"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            if (Array.isArray(_data["pharmacies"])) {
                this.pharmacies = [] as any;
                for (let item of _data["pharmacies"])
                    this.pharmacies.push(PharmacyDto.fromJS(item));
            }
            if (Array.isArray(_data["pharmacists"])) {
                this.pharmacists = [] as any;
                for (let item of _data["pharmacists"])
                    this.pharmacists.push(PharmacistDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(HospitalAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses.push(HospitalLicenseDto.fromJS(item));
            }
            if (Array.isArray(_data["contactMethods"])) {
                this.contactMethods = [] as any;
                for (let item of _data["contactMethods"])
                    this.contactMethods.push(HospitalContactMethodDto.fromJS(item));
            }
            this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs.push(ProgramDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PharmacyHospitalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyHospitalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hospitalProgramId"] = this.hospitalProgramId;
        data["pharmacyProgramId"] = this.pharmacyProgramId;
        data["affiliationTypeClassificationValueId"] = this.affiliationTypeClassificationValueId;
        data["certificationStatusClassificationValueId"] = this.certificationStatusClassificationValueId;
        data["knipperId"] = this.knipperId;
        data["clientHospitalId"] = this.clientHospitalId;
        data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
        data["programEnrolled"] = this.programEnrolled;
        data["enrollmentId"] = this.enrollmentId;
        data["hospitalName"] = this.hospitalName;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        if (Array.isArray(this.pharmacies)) {
            data["pharmacies"] = [];
            for (let item of this.pharmacies)
                data["pharmacies"].push(item.toJSON());
        }
        if (Array.isArray(this.pharmacists)) {
            data["pharmacists"] = [];
            for (let item of this.pharmacists)
                data["pharmacists"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        if (Array.isArray(this.contactMethods)) {
            data["contactMethods"] = [];
            for (let item of this.contactMethods)
                data["contactMethods"].push(item.toJSON());
        }
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): PharmacyHospitalDto {
        const json = this.toJSON();
        let result = new PharmacyHospitalDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacyHospitalDto {
    /** Gets or sets the hospital program Id */
    hospitalProgramId: string | undefined;
    /** Gets or sets the pharmacy program Id */
    pharmacyProgramId: string | undefined;
    /** Gets or sets the Pharmacy Affiliation To Hospital */
    affiliationTypeClassificationValueId: string | undefined;
    /** Gets or sets the certification status To Hospital */
    certificationStatusClassificationValueId: string | undefined;
    /** Gets to sets the KnipperId. */
    knipperId: string | undefined;
    /** Gets to sets the client pharmacist id. */
    clientHospitalId: string | undefined;
    /** Gets to sets the classification value of pharmacist. */
    currentStatusClassificationValueId: string | undefined;
    /** Gets to sets the program enrolled for pharmacist. */
    programEnrolled: string | undefined;
    /** Gets to sets the hospital enrollment id. */
    enrollmentId: string | undefined;
    /** Gets or sets the hospital name. */
    hospitalName: string | undefined;
    /** Gets or Sets the  knipper created pharmacist flag. */
    knipperCreateFlag: boolean | undefined;
    pharmacies: PharmacyDto[] | undefined;
    pharmacists: PharmacistDto[] | undefined;
    addresses: HospitalAddressDto[] | undefined;
    licenses: HospitalLicenseDto[] | undefined;
    /** Gets or sets the pharmacy contact methods. */
    contactMethods: HospitalContactMethodDto[] | undefined;
    /** Gets or sets the Current status of the Hospital */
    currentStatus: ReferencedClassification | undefined;
    /** Gets or sets the Current programs of the Hospital */
    programs: ProgramDto[] | undefined;
    id: string | undefined;
}

export class ReferencedClassification implements IReferencedClassification {
    code: string | undefined;
    name: string | undefined;
    originatingSchema: string | undefined;
    originatingTable: string | undefined;
    rowVersion: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    id: string | undefined;

    constructor(data?: IReferencedClassification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.originatingSchema = _data["originatingSchema"];
            this.originatingTable = _data["originatingTable"];
            this.rowVersion = _data["rowVersion"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReferencedClassification {
        data = typeof data === 'object' ? data : {};
        let result = new ReferencedClassification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["originatingSchema"] = this.originatingSchema;
        data["originatingTable"] = this.originatingTable;
        data["rowVersion"] = this.rowVersion;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ReferencedClassification {
        const json = this.toJSON();
        let result = new ReferencedClassification();
        result.init(json);
        return result;
    }
}

export interface IReferencedClassification {
    code: string | undefined;
    name: string | undefined;
    originatingSchema: string | undefined;
    originatingTable: string | undefined;
    rowVersion: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    id: string | undefined;
}

export class HospitalAddressDto implements IHospitalAddressDto {
    hospitalId: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    primaryAddressFlag: boolean | undefined;
    badAddressFlag: boolean | undefined;
    clientAddressId: string | undefined;
    companyName: string | undefined;
    san: string | undefined;
    groupPracticeName: string | undefined;
    sanExpirationDate: Date | undefined;
    activeFlag: boolean | undefined;
    sourceText: string | undefined;
    sourceNoteText: string | undefined;
    fileName: string | undefined;
    sourceUpdateDateTime: Date | undefined;
    deletionSourceDataTime: Date | undefined;
    deaNbr: string | undefined;
    contactMethods: HospitalContactMethodDto[] | undefined;
    id: string | undefined;

    constructor(data?: IHospitalAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hospitalId = _data["hospitalId"];
            this.stateCode = _data["stateCode"];
            this.countryCode = _data["countryCode"];
            this.address1Text = _data["address1Text"];
            this.address2Text = _data["address2Text"];
            this.address3Text = _data["address3Text"];
            this.address4Text = _data["address4Text"];
            this.cityName = _data["cityName"];
            this.zipCode = _data["zipCode"];
            this.primaryAddressFlag = _data["primaryAddressFlag"];
            this.badAddressFlag = _data["badAddressFlag"];
            this.clientAddressId = _data["clientAddressId"];
            this.companyName = _data["companyName"];
            this.san = _data["san"];
            this.groupPracticeName = _data["groupPracticeName"];
            this.sanExpirationDate = _data["sanExpirationDate"] ? new Date(_data["sanExpirationDate"].toString()) : <any>undefined;
            this.activeFlag = _data["activeFlag"];
            this.sourceText = _data["sourceText"];
            this.sourceNoteText = _data["sourceNoteText"];
            this.fileName = _data["fileName"];
            this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
            this.deletionSourceDataTime = _data["deletionSourceDataTime"] ? new Date(_data["deletionSourceDataTime"].toString()) : <any>undefined;
            this.deaNbr = _data["deaNbr"];
            if (Array.isArray(_data["contactMethods"])) {
                this.contactMethods = [] as any;
                for (let item of _data["contactMethods"])
                    this.contactMethods.push(HospitalContactMethodDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HospitalAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hospitalId"] = this.hospitalId;
        data["stateCode"] = this.stateCode;
        data["countryCode"] = this.countryCode;
        data["address1Text"] = this.address1Text;
        data["address2Text"] = this.address2Text;
        data["address3Text"] = this.address3Text;
        data["address4Text"] = this.address4Text;
        data["cityName"] = this.cityName;
        data["zipCode"] = this.zipCode;
        data["primaryAddressFlag"] = this.primaryAddressFlag;
        data["badAddressFlag"] = this.badAddressFlag;
        data["clientAddressId"] = this.clientAddressId;
        data["companyName"] = this.companyName;
        data["san"] = this.san;
        data["groupPracticeName"] = this.groupPracticeName;
        data["sanExpirationDate"] = this.sanExpirationDate ? this.sanExpirationDate.toISOString() : <any>undefined;
        data["activeFlag"] = this.activeFlag;
        data["sourceText"] = this.sourceText;
        data["sourceNoteText"] = this.sourceNoteText;
        data["fileName"] = this.fileName;
        data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
        data["deletionSourceDataTime"] = this.deletionSourceDataTime ? this.deletionSourceDataTime.toISOString() : <any>undefined;
        data["deaNbr"] = this.deaNbr;
        if (Array.isArray(this.contactMethods)) {
            data["contactMethods"] = [];
            for (let item of this.contactMethods)
                data["contactMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): HospitalAddressDto {
        const json = this.toJSON();
        let result = new HospitalAddressDto();
        result.init(json);
        return result;
    }
}

export interface IHospitalAddressDto {
    hospitalId: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    primaryAddressFlag: boolean | undefined;
    badAddressFlag: boolean | undefined;
    clientAddressId: string | undefined;
    companyName: string | undefined;
    san: string | undefined;
    groupPracticeName: string | undefined;
    sanExpirationDate: Date | undefined;
    activeFlag: boolean | undefined;
    sourceText: string | undefined;
    sourceNoteText: string | undefined;
    fileName: string | undefined;
    sourceUpdateDateTime: Date | undefined;
    deletionSourceDataTime: Date | undefined;
    deaNbr: string | undefined;
    contactMethods: HospitalContactMethodDto[] | undefined;
    id: string | undefined;
}

export class HospitalLicenseDto implements IHospitalLicenseDto {
    hospitalId: string | undefined;
    stateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    sampleEligibilityFlag: boolean | undefined;
    /** Gets or sets the license expiration date */
    licenseExpirationDate: Date | undefined;
    id: string | undefined;

    constructor(data?: IHospitalLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hospitalId = _data["hospitalId"];
            this.stateCode = _data["stateCode"];
            this.stateLicenseNbr = _data["stateLicenseNbr"];
            this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? new Date(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HospitalLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hospitalId"] = this.hospitalId;
        data["stateCode"] = this.stateCode;
        data["stateLicenseNbr"] = this.stateLicenseNbr;
        data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): HospitalLicenseDto {
        const json = this.toJSON();
        let result = new HospitalLicenseDto();
        result.init(json);
        return result;
    }
}

export interface IHospitalLicenseDto {
    hospitalId: string | undefined;
    stateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    sampleEligibilityFlag: boolean | undefined;
    /** Gets or sets the license expiration date */
    licenseExpirationDate: Date | undefined;
    id: string | undefined;
}

export class HospitalContactMethodDto implements IHospitalContactMethodDto {
    hospitalId: string | undefined;
    hospitalAddressId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    knipperCreateFlag: boolean | undefined;
    primaryContactMethodFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IHospitalContactMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hospitalId = _data["hospitalId"];
            this.hospitalAddressId = _data["hospitalAddressId"];
            this.contactMethodTypeId = _data["contactMethodTypeId"];
            this.contactDetailText = _data["contactDetailText"];
            this.contactDetailExtensionText = _data["contactDetailExtensionText"];
            this.knipperCreateFlag = _data["knipperCreateFlag"];
            this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HospitalContactMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalContactMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hospitalId"] = this.hospitalId;
        data["hospitalAddressId"] = this.hospitalAddressId;
        data["contactMethodTypeId"] = this.contactMethodTypeId;
        data["contactDetailText"] = this.contactDetailText;
        data["contactDetailExtensionText"] = this.contactDetailExtensionText;
        data["knipperCreateFlag"] = this.knipperCreateFlag;
        data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): HospitalContactMethodDto {
        const json = this.toJSON();
        let result = new HospitalContactMethodDto();
        result.init(json);
        return result;
    }
}

export interface IHospitalContactMethodDto {
    hospitalId: string | undefined;
    hospitalAddressId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    knipperCreateFlag: boolean | undefined;
    primaryContactMethodFlag: boolean | undefined;
    id: string | undefined;
}

export class ProgramDto implements IProgramDto {
    id: string | undefined;
    programName: string | undefined;
    programDesc: string | undefined;
    jobId: string | undefined;
    patientSamplingJobId: string | undefined;
    projectId: string | undefined;
    projectDesc: string | undefined;
    programTypeClassificationValueId: string | undefined;
    currentStatusClassificationValueId: string | undefined;
    latestConfigurationId: string | undefined;
    latestConfigurationStatusClassificationValueId: string | undefined;
    latestConfigurationStatusDate: Date | undefined;
    repDrivenFlag: boolean | undefined;
    institutionFlag: boolean | undefined;
    /** service offering of the program. */
    moduleId: string | undefined;
    /** HCP brand specialty flag of the program. */
    hcpBrandSpecialtyFlag: boolean | undefined;
    patientSamplingFlag: boolean | undefined;
    projectedStartDate: Date | undefined;
    projectedEndDate: Date | undefined;
    actualStartDate: Date | undefined;
    actualEndDate: Date | undefined;
    shutdownStartDate: Date | undefined;
    reactivationDate: Date | undefined;
    tenantId: number | undefined;
    allowActivation: boolean | undefined;
    scheduledActivationFlag: boolean | undefined;
    canGenerateBlankSrfFlag: boolean | undefined;
    numberOfBlankSrfSets: number | undefined;
    scheduledActivatedDate: Date | undefined;
    allowConfigurationDeletion: boolean | undefined;
    updateOrderByHcpProfileFlag: boolean | undefined;
    opProgramUrl: string | undefined;
    opProgramURLFlag: boolean | undefined;
    targetFileByBrandFlag: boolean | undefined;
    programContactMethods: ProgramContactMethodDto[] | undefined;
    programContacts: ProgramContactDto[] | undefined;
    programAttachments: ProgramAttachmentDto[] | undefined;
    dtpProgramConfigurationHistory: DtpProgramConfigDto[] | undefined;
    programFiles: TenantFileDto[] | undefined;
    names: LocalizedValue[] | undefined;

    constructor(data?: IProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programName = _data["programName"];
            this.programDesc = _data["programDesc"];
            this.jobId = _data["jobId"];
            this.patientSamplingJobId = _data["patientSamplingJobId"];
            this.projectId = _data["projectId"];
            this.projectDesc = _data["projectDesc"];
            this.programTypeClassificationValueId = _data["programTypeClassificationValueId"];
            this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
            this.latestConfigurationId = _data["latestConfigurationId"];
            this.latestConfigurationStatusClassificationValueId = _data["latestConfigurationStatusClassificationValueId"];
            this.latestConfigurationStatusDate = _data["latestConfigurationStatusDate"] ? new Date(_data["latestConfigurationStatusDate"].toString()) : <any>undefined;
            this.repDrivenFlag = _data["repDrivenFlag"];
            this.institutionFlag = _data["institutionFlag"];
            this.moduleId = _data["moduleId"];
            this.hcpBrandSpecialtyFlag = _data["hcpBrandSpecialtyFlag"];
            this.patientSamplingFlag = _data["patientSamplingFlag"];
            this.projectedStartDate = _data["projectedStartDate"] ? new Date(_data["projectedStartDate"].toString()) : <any>undefined;
            this.projectedEndDate = _data["projectedEndDate"] ? new Date(_data["projectedEndDate"].toString()) : <any>undefined;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : <any>undefined;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : <any>undefined;
            this.shutdownStartDate = _data["shutdownStartDate"] ? new Date(_data["shutdownStartDate"].toString()) : <any>undefined;
            this.reactivationDate = _data["reactivationDate"] ? new Date(_data["reactivationDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.allowActivation = _data["allowActivation"];
            this.scheduledActivationFlag = _data["scheduledActivationFlag"];
            this.canGenerateBlankSrfFlag = _data["canGenerateBlankSrfFlag"];
            this.numberOfBlankSrfSets = _data["numberOfBlankSrfSets"];
            this.scheduledActivatedDate = _data["scheduledActivatedDate"] ? new Date(_data["scheduledActivatedDate"].toString()) : <any>undefined;
            this.allowConfigurationDeletion = _data["allowConfigurationDeletion"];
            this.updateOrderByHcpProfileFlag = _data["updateOrderByHcpProfileFlag"];
            this.opProgramUrl = _data["opProgramUrl"];
            this.opProgramURLFlag = _data["opProgramURLFlag"];
            this.targetFileByBrandFlag = _data["targetFileByBrandFlag"];
            if (Array.isArray(_data["programContactMethods"])) {
                this.programContactMethods = [] as any;
                for (let item of _data["programContactMethods"])
                    this.programContactMethods.push(ProgramContactMethodDto.fromJS(item));
            }
            if (Array.isArray(_data["programContacts"])) {
                this.programContacts = [] as any;
                for (let item of _data["programContacts"])
                    this.programContacts.push(ProgramContactDto.fromJS(item));
            }
            if (Array.isArray(_data["programAttachments"])) {
                this.programAttachments = [] as any;
                for (let item of _data["programAttachments"])
                    this.programAttachments.push(ProgramAttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["dtpProgramConfigurationHistory"])) {
                this.dtpProgramConfigurationHistory = [] as any;
                for (let item of _data["dtpProgramConfigurationHistory"])
                    this.dtpProgramConfigurationHistory.push(DtpProgramConfigDto.fromJS(item));
            }
            if (Array.isArray(_data["programFiles"])) {
                this.programFiles = [] as any;
                for (let item of _data["programFiles"])
                    this.programFiles.push(TenantFileDto.fromJS(item));
            }
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programName"] = this.programName;
        data["programDesc"] = this.programDesc;
        data["jobId"] = this.jobId;
        data["patientSamplingJobId"] = this.patientSamplingJobId;
        data["projectId"] = this.projectId;
        data["projectDesc"] = this.projectDesc;
        data["programTypeClassificationValueId"] = this.programTypeClassificationValueId;
        data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
        data["latestConfigurationId"] = this.latestConfigurationId;
        data["latestConfigurationStatusClassificationValueId"] = this.latestConfigurationStatusClassificationValueId;
        data["latestConfigurationStatusDate"] = this.latestConfigurationStatusDate ? this.latestConfigurationStatusDate.toISOString() : <any>undefined;
        data["repDrivenFlag"] = this.repDrivenFlag;
        data["institutionFlag"] = this.institutionFlag;
        data["moduleId"] = this.moduleId;
        data["hcpBrandSpecialtyFlag"] = this.hcpBrandSpecialtyFlag;
        data["patientSamplingFlag"] = this.patientSamplingFlag;
        data["projectedStartDate"] = this.projectedStartDate ? this.projectedStartDate.toISOString() : <any>undefined;
        data["projectedEndDate"] = this.projectedEndDate ? this.projectedEndDate.toISOString() : <any>undefined;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : <any>undefined;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : <any>undefined;
        data["shutdownStartDate"] = this.shutdownStartDate ? this.shutdownStartDate.toISOString() : <any>undefined;
        data["reactivationDate"] = this.reactivationDate ? this.reactivationDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["allowActivation"] = this.allowActivation;
        data["scheduledActivationFlag"] = this.scheduledActivationFlag;
        data["canGenerateBlankSrfFlag"] = this.canGenerateBlankSrfFlag;
        data["numberOfBlankSrfSets"] = this.numberOfBlankSrfSets;
        data["scheduledActivatedDate"] = this.scheduledActivatedDate ? this.scheduledActivatedDate.toISOString() : <any>undefined;
        data["allowConfigurationDeletion"] = this.allowConfigurationDeletion;
        data["updateOrderByHcpProfileFlag"] = this.updateOrderByHcpProfileFlag;
        data["opProgramUrl"] = this.opProgramUrl;
        data["opProgramURLFlag"] = this.opProgramURLFlag;
        data["targetFileByBrandFlag"] = this.targetFileByBrandFlag;
        if (Array.isArray(this.programContactMethods)) {
            data["programContactMethods"] = [];
            for (let item of this.programContactMethods)
                data["programContactMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.programContacts)) {
            data["programContacts"] = [];
            for (let item of this.programContacts)
                data["programContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.programAttachments)) {
            data["programAttachments"] = [];
            for (let item of this.programAttachments)
                data["programAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.dtpProgramConfigurationHistory)) {
            data["dtpProgramConfigurationHistory"] = [];
            for (let item of this.dtpProgramConfigurationHistory)
                data["dtpProgramConfigurationHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.programFiles)) {
            data["programFiles"] = [];
            for (let item of this.programFiles)
                data["programFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProgramDto {
        const json = this.toJSON();
        let result = new ProgramDto();
        result.init(json);
        return result;
    }
}

export interface IProgramDto {
    id: string | undefined;
    programName: string | undefined;
    programDesc: string | undefined;
    jobId: string | undefined;
    patientSamplingJobId: string | undefined;
    projectId: string | undefined;
    projectDesc: string | undefined;
    programTypeClassificationValueId: string | undefined;
    currentStatusClassificationValueId: string | undefined;
    latestConfigurationId: string | undefined;
    latestConfigurationStatusClassificationValueId: string | undefined;
    latestConfigurationStatusDate: Date | undefined;
    repDrivenFlag: boolean | undefined;
    institutionFlag: boolean | undefined;
    /** service offering of the program. */
    moduleId: string | undefined;
    /** HCP brand specialty flag of the program. */
    hcpBrandSpecialtyFlag: boolean | undefined;
    patientSamplingFlag: boolean | undefined;
    projectedStartDate: Date | undefined;
    projectedEndDate: Date | undefined;
    actualStartDate: Date | undefined;
    actualEndDate: Date | undefined;
    shutdownStartDate: Date | undefined;
    reactivationDate: Date | undefined;
    tenantId: number | undefined;
    allowActivation: boolean | undefined;
    scheduledActivationFlag: boolean | undefined;
    canGenerateBlankSrfFlag: boolean | undefined;
    numberOfBlankSrfSets: number | undefined;
    scheduledActivatedDate: Date | undefined;
    allowConfigurationDeletion: boolean | undefined;
    updateOrderByHcpProfileFlag: boolean | undefined;
    opProgramUrl: string | undefined;
    opProgramURLFlag: boolean | undefined;
    targetFileByBrandFlag: boolean | undefined;
    programContactMethods: ProgramContactMethodDto[] | undefined;
    programContacts: ProgramContactDto[] | undefined;
    programAttachments: ProgramAttachmentDto[] | undefined;
    dtpProgramConfigurationHistory: DtpProgramConfigDto[] | undefined;
    programFiles: TenantFileDto[] | undefined;
    names: LocalizedValue[] | undefined;
}

export class ProgramContactMethodDto implements IProgramContactMethodDto {
    programId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    primaryFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IProgramContactMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.contactMethodTypeId = _data["contactMethodTypeId"];
            this.contactDetailText = _data["contactDetailText"];
            this.contactDetailExtensionText = _data["contactDetailExtensionText"];
            this.primaryFlag = _data["primaryFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgramContactMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramContactMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["contactMethodTypeId"] = this.contactMethodTypeId;
        data["contactDetailText"] = this.contactDetailText;
        data["contactDetailExtensionText"] = this.contactDetailExtensionText;
        data["primaryFlag"] = this.primaryFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): ProgramContactMethodDto {
        const json = this.toJSON();
        let result = new ProgramContactMethodDto();
        result.init(json);
        return result;
    }
}

export interface IProgramContactMethodDto {
    programId: string | undefined;
    contactMethodTypeId: string | undefined;
    contactDetailText: string | undefined;
    contactDetailExtensionText: string | undefined;
    primaryFlag: boolean | undefined;
    id: string | undefined;
}

export class ProgramContactDto implements IProgramContactDto {
    programId: string | undefined;
    roleClassificationValueId: string | undefined;
    userProfileId: string | undefined;
    newFlag: boolean | undefined;
    id: string | undefined;

    constructor(data?: IProgramContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.roleClassificationValueId = _data["roleClassificationValueId"];
            this.userProfileId = _data["userProfileId"];
            this.newFlag = _data["newFlag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgramContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["roleClassificationValueId"] = this.roleClassificationValueId;
        data["userProfileId"] = this.userProfileId;
        data["newFlag"] = this.newFlag;
        data["id"] = this.id;
        return data;
    }

    clone(): ProgramContactDto {
        const json = this.toJSON();
        let result = new ProgramContactDto();
        result.init(json);
        return result;
    }
}

export interface IProgramContactDto {
    programId: string | undefined;
    roleClassificationValueId: string | undefined;
    userProfileId: string | undefined;
    newFlag: boolean | undefined;
    id: string | undefined;
}

export class ProgramAttachmentDto implements IProgramAttachmentDto {
    programId: string | undefined;
    location: string | undefined;
    comments: string | undefined;
    attachmentTypeClassificationValueId: string | undefined;
    sequenceNumber: number | undefined;
    newFlag: boolean | undefined;
    fileUpload: FileUpload | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    id: string | undefined;

    constructor(data?: IProgramAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.location = _data["location"];
            this.comments = _data["comments"];
            this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.newFlag = _data["newFlag"];
            this.fileUpload = _data["fileUpload"] ? FileUpload.fromJS(_data["fileUpload"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProgramAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["location"] = this.location;
        data["comments"] = this.comments;
        data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
        data["sequenceNumber"] = this.sequenceNumber;
        data["newFlag"] = this.newFlag;
        data["fileUpload"] = this.fileUpload ? this.fileUpload.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): ProgramAttachmentDto {
        const json = this.toJSON();
        let result = new ProgramAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IProgramAttachmentDto {
    programId: string | undefined;
    location: string | undefined;
    comments: string | undefined;
    attachmentTypeClassificationValueId: string | undefined;
    sequenceNumber: number | undefined;
    newFlag: boolean | undefined;
    fileUpload: FileUpload | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    id: string | undefined;
}

export class DtpProgramConfigDto implements IDtpProgramConfigDto {
    dtpProgramConfigurationId: string | undefined;
    currentStatusClassificationValueId: string | undefined;
    aocFollowUpLetterFlag: boolean | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    allowPushToLive: boolean | undefined;
    activationDate: Date | undefined;
    id: string | undefined;

    constructor(data?: IDtpProgramConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
            this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
            this.aocFollowUpLetterFlag = _data["aocFollowUpLetterFlag"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.allowPushToLive = _data["allowPushToLive"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DtpProgramConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new DtpProgramConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
        data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
        data["aocFollowUpLetterFlag"] = this.aocFollowUpLetterFlag;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["allowPushToLive"] = this.allowPushToLive;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): DtpProgramConfigDto {
        const json = this.toJSON();
        let result = new DtpProgramConfigDto();
        result.init(json);
        return result;
    }
}

export interface IDtpProgramConfigDto {
    dtpProgramConfigurationId: string | undefined;
    currentStatusClassificationValueId: string | undefined;
    aocFollowUpLetterFlag: boolean | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    allowPushToLive: boolean | undefined;
    activationDate: Date | undefined;
    id: string | undefined;
}

export class TenantFileDto implements ITenantFileDto {
    fileTypeId: string | undefined;
    hasErrors: boolean | undefined;
    hasMissingFile: boolean | undefined;
    fileName: string | undefined;
    fileLocation: string | undefined;
    lastUpdatedDateTime: Date | undefined;

    constructor(data?: ITenantFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileTypeId = _data["fileTypeId"];
            this.hasErrors = _data["hasErrors"];
            this.hasMissingFile = _data["hasMissingFile"];
            this.fileName = _data["fileName"];
            this.fileLocation = _data["fileLocation"];
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"] ? new Date(_data["lastUpdatedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileTypeId"] = this.fileTypeId;
        data["hasErrors"] = this.hasErrors;
        data["hasMissingFile"] = this.hasMissingFile;
        data["fileName"] = this.fileName;
        data["fileLocation"] = this.fileLocation;
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TenantFileDto {
        const json = this.toJSON();
        let result = new TenantFileDto();
        result.init(json);
        return result;
    }
}

export interface ITenantFileDto {
    fileTypeId: string | undefined;
    hasErrors: boolean | undefined;
    hasMissingFile: boolean | undefined;
    fileName: string | undefined;
    fileLocation: string | undefined;
    lastUpdatedDateTime: Date | undefined;
}

export class FileUpload implements IFileUpload {
    fileName: string | undefined;
    fileDescription: string | undefined;
    fileType: string | undefined;
    base64FileContent: string | undefined;
    location: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    newFlag: boolean | undefined;
    duplicateFileName: boolean | undefined;

    constructor(data?: IFileUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileDescription = _data["fileDescription"];
            this.fileType = _data["fileType"];
            this.base64FileContent = _data["base64FileContent"];
            this.location = _data["location"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.newFlag = _data["newFlag"];
            this.duplicateFileName = _data["duplicateFileName"];
        }
    }

    static fromJS(data: any): FileUpload {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileDescription"] = this.fileDescription;
        data["fileType"] = this.fileType;
        data["base64FileContent"] = this.base64FileContent;
        data["location"] = this.location;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["newFlag"] = this.newFlag;
        data["duplicateFileName"] = this.duplicateFileName;
        return data;
    }

    clone(): FileUpload {
        const json = this.toJSON();
        let result = new FileUpload();
        result.init(json);
        return result;
    }
}

export interface IFileUpload {
    fileName: string | undefined;
    fileDescription: string | undefined;
    fileType: string | undefined;
    base64FileContent: string | undefined;
    location: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    newFlag: boolean | undefined;
    duplicateFileName: boolean | undefined;
}

export class PharmacistSearchFilterDto implements IPharmacistSearchFilterDto {
    pharmacistLastName: string | undefined;
    pharmacistFirstName: string | undefined;
    pharmacistKId: string | undefined;
    clientTargetId: string | undefined;
    stateCode: string | undefined;
    zipCode: string | undefined;
    emailAddress: string | undefined;
    stateLicenseNumber: string | undefined;
    deaNumber: string | undefined;
    san: string | undefined;
    currentStatusClassificationValueIds: string[] | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;

    constructor(data?: IPharmacistSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacistLastName = _data["pharmacistLastName"];
            this.pharmacistFirstName = _data["pharmacistFirstName"];
            this.pharmacistKId = _data["pharmacistKId"];
            this.clientTargetId = _data["clientTargetId"];
            this.stateCode = _data["stateCode"];
            this.zipCode = _data["zipCode"];
            this.emailAddress = _data["emailAddress"];
            this.stateLicenseNumber = _data["stateLicenseNumber"];
            this.deaNumber = _data["deaNumber"];
            this.san = _data["san"];
            if (Array.isArray(_data["currentStatusClassificationValueIds"])) {
                this.currentStatusClassificationValueIds = [] as any;
                for (let item of _data["currentStatusClassificationValueIds"])
                    this.currentStatusClassificationValueIds.push(item);
            }
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.sortBy = _data["sortBy"];
            this.filterString = _data["filterString"];
        }
    }

    static fromJS(data: any): PharmacistSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacistSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacistLastName"] = this.pharmacistLastName;
        data["pharmacistFirstName"] = this.pharmacistFirstName;
        data["pharmacistKId"] = this.pharmacistKId;
        data["clientTargetId"] = this.clientTargetId;
        data["stateCode"] = this.stateCode;
        data["zipCode"] = this.zipCode;
        data["emailAddress"] = this.emailAddress;
        data["stateLicenseNumber"] = this.stateLicenseNumber;
        data["deaNumber"] = this.deaNumber;
        data["san"] = this.san;
        if (Array.isArray(this.currentStatusClassificationValueIds)) {
            data["currentStatusClassificationValueIds"] = [];
            for (let item of this.currentStatusClassificationValueIds)
                data["currentStatusClassificationValueIds"].push(item);
        }
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["sortBy"] = this.sortBy;
        data["filterString"] = this.filterString;
        return data;
    }

    clone(): PharmacistSearchFilterDto {
        const json = this.toJSON();
        let result = new PharmacistSearchFilterDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacistSearchFilterDto {
    pharmacistLastName: string | undefined;
    pharmacistFirstName: string | undefined;
    pharmacistKId: string | undefined;
    clientTargetId: string | undefined;
    stateCode: string | undefined;
    zipCode: string | undefined;
    emailAddress: string | undefined;
    stateLicenseNumber: string | undefined;
    deaNumber: string | undefined;
    san: string | undefined;
    currentStatusClassificationValueIds: string[] | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfPharmacistSearchDto implements IAjaxResponseOfPagedResultOfPharmacistSearchDto {
    result: PagedResultOfPharmacistSearchDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPagedResultOfPharmacistSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PagedResultOfPharmacistSearchDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPagedResultOfPharmacistSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPagedResultOfPharmacistSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPagedResultOfPharmacistSearchDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPagedResultOfPharmacistSearchDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPagedResultOfPharmacistSearchDto {
    result: PagedResultOfPharmacistSearchDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PagedResultOfPharmacistSearchDto implements IPagedResultOfPharmacistSearchDto {
    totalCount: number | undefined;
    items: PharmacistSearchDto[] | undefined;

    constructor(data?: IPagedResultOfPharmacistSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PharmacistSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfPharmacistSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPharmacistSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultOfPharmacistSearchDto {
        const json = this.toJSON();
        let result = new PagedResultOfPharmacistSearchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfPharmacistSearchDto {
    totalCount: number | undefined;
    items: PharmacistSearchDto[] | undefined;
}

export class PharmacistSearchDto implements IPharmacistSearchDto {
    id: string | undefined;
    pharmacistName: string | undefined;
    pharmacistKId: string | undefined;
    primaryAddress: PharmacyAddressDto | undefined;
    emailAddress: string | undefined;
    primaryStateLicenseNumber: string | undefined;
    primaryDeaNumber: string | undefined;
    primarySan: string | undefined;
    pharmacistStatus: string | undefined;
    clientTargetId: string | undefined;
    primaryPhoneNumber: string | undefined;
    primaryFaxNumber: string | undefined;
    nonPrimaryAddressCount: number | undefined;
    nonPrimaryStateLicenseNumberCount: number | undefined;
    nonPrimaryDeaNumberCount: number | undefined;
    nonPrimarySanCount: number | undefined;
    nonPrimaryPhoneNumberCount: number | undefined;
    nonPrimaryFaxNumberCount: number | undefined;
    pharmacistFirstName: string | undefined;
    pharmacistLastName: string | undefined;
    stateLicenses: string | undefined;
    names: LocalizedValue[] | undefined;

    constructor(data?: IPharmacistSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pharmacistName = _data["pharmacistName"];
            this.pharmacistKId = _data["pharmacistKId"];
            this.primaryAddress = _data["primaryAddress"] ? PharmacyAddressDto.fromJS(_data["primaryAddress"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.primaryStateLicenseNumber = _data["primaryStateLicenseNumber"];
            this.primaryDeaNumber = _data["primaryDeaNumber"];
            this.primarySan = _data["primarySan"];
            this.pharmacistStatus = _data["pharmacistStatus"];
            this.clientTargetId = _data["clientTargetId"];
            this.primaryPhoneNumber = _data["primaryPhoneNumber"];
            this.primaryFaxNumber = _data["primaryFaxNumber"];
            this.nonPrimaryAddressCount = _data["nonPrimaryAddressCount"];
            this.nonPrimaryStateLicenseNumberCount = _data["nonPrimaryStateLicenseNumberCount"];
            this.nonPrimaryDeaNumberCount = _data["nonPrimaryDeaNumberCount"];
            this.nonPrimarySanCount = _data["nonPrimarySanCount"];
            this.nonPrimaryPhoneNumberCount = _data["nonPrimaryPhoneNumberCount"];
            this.nonPrimaryFaxNumberCount = _data["nonPrimaryFaxNumberCount"];
            this.pharmacistFirstName = _data["pharmacistFirstName"];
            this.pharmacistLastName = _data["pharmacistLastName"];
            this.stateLicenses = _data["stateLicenses"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PharmacistSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacistSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pharmacistName"] = this.pharmacistName;
        data["pharmacistKId"] = this.pharmacistKId;
        data["primaryAddress"] = this.primaryAddress ? this.primaryAddress.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["primaryStateLicenseNumber"] = this.primaryStateLicenseNumber;
        data["primaryDeaNumber"] = this.primaryDeaNumber;
        data["primarySan"] = this.primarySan;
        data["pharmacistStatus"] = this.pharmacistStatus;
        data["clientTargetId"] = this.clientTargetId;
        data["primaryPhoneNumber"] = this.primaryPhoneNumber;
        data["primaryFaxNumber"] = this.primaryFaxNumber;
        data["nonPrimaryAddressCount"] = this.nonPrimaryAddressCount;
        data["nonPrimaryStateLicenseNumberCount"] = this.nonPrimaryStateLicenseNumberCount;
        data["nonPrimaryDeaNumberCount"] = this.nonPrimaryDeaNumberCount;
        data["nonPrimarySanCount"] = this.nonPrimarySanCount;
        data["nonPrimaryPhoneNumberCount"] = this.nonPrimaryPhoneNumberCount;
        data["nonPrimaryFaxNumberCount"] = this.nonPrimaryFaxNumberCount;
        data["pharmacistFirstName"] = this.pharmacistFirstName;
        data["pharmacistLastName"] = this.pharmacistLastName;
        data["stateLicenses"] = this.stateLicenses;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        return data;
    }

    clone(): PharmacistSearchDto {
        const json = this.toJSON();
        let result = new PharmacistSearchDto();
        result.init(json);
        return result;
    }
}

export interface IPharmacistSearchDto {
    id: string | undefined;
    pharmacistName: string | undefined;
    pharmacistKId: string | undefined;
    primaryAddress: PharmacyAddressDto | undefined;
    emailAddress: string | undefined;
    primaryStateLicenseNumber: string | undefined;
    primaryDeaNumber: string | undefined;
    primarySan: string | undefined;
    pharmacistStatus: string | undefined;
    clientTargetId: string | undefined;
    primaryPhoneNumber: string | undefined;
    primaryFaxNumber: string | undefined;
    nonPrimaryAddressCount: number | undefined;
    nonPrimaryStateLicenseNumberCount: number | undefined;
    nonPrimaryDeaNumberCount: number | undefined;
    nonPrimarySanCount: number | undefined;
    nonPrimaryPhoneNumberCount: number | undefined;
    nonPrimaryFaxNumberCount: number | undefined;
    pharmacistFirstName: string | undefined;
    pharmacistLastName: string | undefined;
    stateLicenses: string | undefined;
    names: LocalizedValue[] | undefined;
}

export class AjaxResponseOfListOfPharmacistDto implements IAjaxResponseOfListOfPharmacistDto {
    result: PharmacistDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfPharmacistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(PharmacistDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfPharmacistDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfPharmacistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfPharmacistDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfPharmacistDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfPharmacistDto {
    result: PharmacistDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfListOfPharmacyDto implements IAjaxResponseOfListOfPharmacyDto {
    result: PharmacyDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfPharmacyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(PharmacyDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfPharmacyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfPharmacyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfPharmacyDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfPharmacyDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfPharmacyDto {
    result: PharmacyDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfHospitalDto implements IAjaxResponseOfHospitalDto {
    result: HospitalDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfHospitalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? HospitalDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfHospitalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfHospitalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfHospitalDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfHospitalDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfHospitalDto {
    result: HospitalDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfPharmacyDto implements IAjaxResponseOfPharmacyDto {
    result: PharmacyDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPharmacyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PharmacyDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPharmacyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPharmacyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPharmacyDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPharmacyDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPharmacyDto {
    result: PharmacyDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export enum LocalizedValueLanguage {
    _0 = 0,
    _1 = 1,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}